export {LogoHProduceDarkGreen, LogoPredictLanding} from '@hconnect/uikit/src/common'
